/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ChangeDeliveryWorkflowStatusDto } from '../../models/change-delivery-workflow-status-dto';
import { DeliveryItem } from '../../models/delivery-item';

export interface DeliveryControllerChangeDeliveryWorkflowStatus$Params {
  id: number;
      body: ChangeDeliveryWorkflowStatusDto
}

export function deliveryControllerChangeDeliveryWorkflowStatus(http: HttpClient, rootUrl: string, params: DeliveryControllerChangeDeliveryWorkflowStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>> {
  const rb = new RequestBuilder(rootUrl, deliveryControllerChangeDeliveryWorkflowStatus.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DeliveryItem;
      }>;
    })
  );
}

deliveryControllerChangeDeliveryWorkflowStatus.PATH = '/delivery/change-delivery-status/{id}';
